import * as React from 'react';

import DiyAviaryEditorDialog from 'diy/aviary/DiyAviaryEditorDialog';

export interface AviaryStateProps {
    open: boolean;
    options: {
        origImageUrl: string;
        transformedImageUrl?: string;
        imageMediaType: string;
    };
}

export interface AviaryDispatchProps {
    onAviaryClose(): void;
    onAviarySave(imageDataUrl: string): void;
}

interface AviaryProps extends AviaryStateProps, AviaryDispatchProps {

}

interface AviaryState {

}

export class Aviary extends React.Component<AviaryProps, AviaryState> {
    render() {
        if (!this.props.open) {
            return null;
        }

        let sourceImageUrl = this.props.options.transformedImageUrl ?
                    this.props.options.transformedImageUrl :
                    this.props.options.origImageUrl;
        let mediaType = this.props.options.imageMediaType;

        return (
            <DiyAviaryEditorDialog
                imageUrl={sourceImageUrl}
                resultFileFormat={
                    (mediaType === 'jpg' || mediaType === 'jpeg') ? 'jpg' : 'png'
                }
                originalImageUrl={this.props.options.origImageUrl}
                onClose={() => this.onAviaryClose()}
                onSave={(data) => this.onAviarySave(data.imageDataUrl)}
            />
        );
    }

    private onAviaryClose() {
        this.props.onAviaryClose();
    }

    private onAviarySave(imageDataUrl: string) {
        this.props.onAviarySave(imageDataUrl);
    }

}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/components/aviary/Aviary.tsx
 **/